import PlaqueReportPage from '@/pages/PlaqueReportPage/PlaqueReportPage.vue'

export default PlaqueReportPage
